import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Icon } from 'semantic-ui-react';
import { Grid } from '@material-ui/core';
import { getPersonalClaimModels } from '../../../redux/modules/carMarks';
import TextInputFieldWithValidation from '../../ValidationFormElements/TextInputFieldWithValidation';
import SelectWithValidation from '../../ValidationFormElements/SelectWithValidation';

import styles from './styles.module.scss';

const VehicleRow = (props) => {
  const {
    subTitleNum,
    vehicleData,
    onVehicleDataChange,
    isDeletable,
    deleteVehicle,
    manufacturers,
    errors,
    clearError,
  } = props;

  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { personalClaimModels } = useSelector((store) => store.carMarks, shallowEqual);
  const { id } = vehicleData;
  const [stateNumber, setStateNumber] = useState(vehicleData.stateNumber);
  const [manufacturer, setManufacturer] = useState(vehicleData.manufacturer);
  const [models, setModels] = useState([]);
  const [model, setModel] = useState(vehicleData.model);

  useEffect(() => {
    if (manufacturer) {
      if (manufacturer.id in personalClaimModels) setModels(personalClaimModels[manufacturer.id]);
    }
  }, [manufacturer, personalClaimModels, setModels]);

  const handleStateNumChange = (target) => {
    const newValue = target.value.replace(' ', '');
    setStateNumber(newValue);
    onVehicleDataChange({ ...vehicleData, stateNumber: newValue }, 'stateNumber');
  };

  const handleManufacturerChange = (m) => {
    if (!manufacturer || (manufacturer && m.id !== manufacturer.id)) {
      setManufacturer(m);
      setModel(null);
      onVehicleDataChange({ ...vehicleData, manufacturer: m, model: null }, 'manufacturer');
      if (!(m.id in personalClaimModels)) {
        dispatch(getPersonalClaimModels([m.id]));
      }
    }
  };

  const handleModelChange = (m) => {
    setModel(m);
    onVehicleDataChange({ ...vehicleData, model: m }, 'model');
  };

  return (
    <>
      <div className={styles.subTitleRow}>
        <div className={styles.subTitle}>
          {`${t('personalClaim.accInfo.subTitle')} ${subTitleNum}`}
        </div>
      </div>
      <div className={styles.vehicleRowWrapper}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={3}>
            <TextInputFieldWithValidation
              formProps={{ errors, clearError }}
              labelKey="claim.personalData.stateNum"
              name={`stateNumber_${id}`}
              handleChange={(e) => handleStateNumChange(e.target)}
              value={stateNumber}
              required
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <SelectWithValidation
              formProps={{
                errors,
                clearError,
              }}
              value={manufacturer || ''}
              options={manufacturers}
              getMenuLabel={(option) => option.name}
              onChange={handleManufacturerChange}
              label="claim.personalData.manufacturer"
              name={`manufacturer_${id}`}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <SelectWithValidation
              formProps={{
                errors,
                clearError,
              }}
              value={model || ''}
              options={models}
              getMenuLabel={(option) => option.name}
              onChange={handleModelChange}
              label="claim.personalData.model"
              name={`manufacturer_${id}`}
            />
          </Grid>
          <Grid item xs={1}>
            {isDeletable && (
              <div
                className={styles.minusIcon}
                onClick={() => deleteVehicle(id)}
                role="presentation"
              >
                <Icon name="minus circle" className={styles.removeIcon} />
              </div>
            )}
          </Grid>
        </Grid>
      </div>
    </>
  );
};

VehicleRow.propTypes = {
  subTitleNum: PropTypes.number.isRequired,
  vehicleData: PropTypes.shape({
    id: PropTypes.number.isRequired,
    stateNumber: PropTypes.string,
    manufacturer: PropTypes.shape({}),
    model: PropTypes.shape({}),
  }).isRequired,
  onVehicleDataChange: PropTypes.func.isRequired,
  isDeletable: PropTypes.bool.isRequired,
  deleteVehicle: PropTypes.func.isRequired,
  manufacturers: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  errors: PropTypes.shape({}).isRequired,
  clearError: PropTypes.func.isRequired,
};

export default VehicleRow;
